import { render, staticRenderFns } from "./ViewSettingsSlice.vue?vue&type=template&id=5f646410&scoped=true&"
import script from "./ViewSettingsSlice.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsSlice.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsSlice.vue?vue&type=style&index=0&id=5f646410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f646410",
  null
  
)

export default component.exports